// extracted by mini-css-extract-plugin
export default {"box":"iqt-banner_box__uOaSO","label":"iqt-banner_label__HwGbs","entry":"iqt-banner_entry__++oGa","loader":"iqt-banner_loader__5GEI5"};